(() => {
  // Load Facebook Pixel script
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );

  const config = window.APP_CONFIG?.facebook_pixel || {};

  // Init pixels
  if (config.revokeByDefault) {
    fbq('consent', 'revoke');
  }

  if (config.analyticsId) {
    fbq('init', config.analyticsId);
  }

  if (config.adsId) {
    fbq('init', config.adsId);
  }

  function handleConsent(hasConsent) {
    fbq('consent', hasConsent ? 'grant' : 'revoke');
  }

  if (config.revokeByDefault) {
    document.addEventListener('cookieyes_consent_update', (event) => {
      const data = event.detail;
      handleConsent(
        data.accepted &&
          data.accepted.includes('analytics') &&
          data.accepted.includes('advertising'),
      );
    });

    document.addEventListener('cookieyes_banner_load', (event) => {
      const data = event.detail;
      handleConsent(
        data.categories &&
          data.categories.analytics &&
          data.categories.advertising,
      );
    });
  }

  function trackPageView() {
    fbq('track', 'PageView');
  }

  document.addEventListener(
    'turbo:load',
    () => {
      trackPageView();
    },
    true,
  );
})();
